export default {
  infoText: 'Die Tabelle listet Geburtstage aller Berater, nach Geburtsmonat auf.',
};
